import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalClusterConfigWizard = _resolveComponent("ModalClusterConfigWizard")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CardLocation = _resolveComponent("CardLocation")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_HeightDeployer = _resolveComponent("HeightDeployer")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_BadgeSoon = _resolveComponent("BadgeSoon")!
  const _component_CustomNumberInput = _resolveComponent("CustomNumberInput")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-2 mpc-map" }, {
    default: _withCtx(() => [
      _createVNode(_component_ModalClusterConfigWizard, {
        visible: _ctx.wizardVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.wizardVisible) = $event)),
        criticality: _ctx.criticality,
        requireGPU: _ctx.requireGPU,
        "onUpdate:criticality": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:criticality', $event))),
        "onUpdate:requireGPU": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:requireGPU', $event))),
        "onUpdate:selectedCountry": _cache[3] || (_cache[3] = ($event: any) => (
        _ctx.$emit('update:selectedCountry', _ctx.refMap.onSelectCountry($event))
      ))
      }, null, 8, ["visible", "criticality", "requireGPU"]),
      _createVNode(_component_v_col, { class: "pa-0 mr-2 col-left" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0 ml-2 top-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0 pl-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Wizard ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomButton, {
                        class: "my-auto full-width",
                        level: _ctx.$enums.ButtonLevels.Primary,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wizardVisible = true))
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode(" Open wizard ")
                        ])),
                        _: 1
                      }, 8, ["level"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0 ml-4 mr-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode(" Criticality ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomSelect, {
                        items: _ctx.criticalityListItems,
                        modelValue: _ctx.criticalityListItem,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.criticalityListItem) = $event)),
                          _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:criticality', $event.value)))
                        ]
                      }, null, 8, ["items", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0 px-3 col-locations" }, {
                default: _withCtx(() => [
                  (_ctx.filteredLocations?.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.filteredLocationsInView.length)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "ma-0 token-text-h5 pl-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  icon: "eye",
                                  class: "ma-0 mr-2"
                                }),
                                _cache[19] || (_cache[19] = _createElementVNode("span", null, " In view ", -1)),
                                _createVNode(_component_CustomButton, {
                                  class: "ml-auto my-auto",
                                  level: _ctx.$enums.ButtonLevels.SmallIcon,
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.inViewCardsDeployed = !_ctx.inViewCardsDeployed))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      icon: "caret-down",
                                      class: _normalizeClass(["caret", { invert: _ctx.inViewCardsDeployed }])
                                    }, null, 8, ["class"])
                                  ]),
                                  _: 1
                                }, 8, ["level"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_HeightDeployer, {
                          modelValue: _ctx.inViewCardsDeployed,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inViewCardsDeployed) = $event)),
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocationsInView, (location, index) => {
                              return (_openBlock(), _createBlock(_component_v_row, {
                                class: "ma-0",
                                key: 'location-card-' + index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Tooltip, {
                                    hoverOnly: true,
                                    forcedPosition: "right",
                                    disabled: 
                    location.attributes.available_server_typologies.length !== 0
                  ,
                                    class: "full-width"
                                  }, {
                                    target: _withCtx(() => [
                                      _createVNode(_component_CardLocation, {
                                        class: "pointer my-1",
                                        location: location,
                                        disabled: 
                        location.attributes.available_server_typologies
                          .length === 0
                      ,
                                        minPrice: 
                        _ctx.minPricesByLocationId[location.id]
                          ? _ctx.$helpers.prices.format(
                              _ctx.minPricesByLocationId[location.id],
                              _ctx.currency,
                              0,
                            )
                          : ''
                      ,
                                        selected: _ctx.currentLocation?.id === location.id,
                                        onClick: ($event: any) => {
                        if (
                          location.attributes.available_server_typologies
                            .length !== 0
                        )
                          _ctx.selectLocation(location);
                      }
                                      }, null, 8, ["location", "disabled", "minPrice", "selected", "onClick"])
                                    ]),
                                    content: _withCtx(() => _cache[20] || (_cache[20] = [
                                      _createTextVNode(" This location is temporarily unavailable."),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" This can be due to a lack of server availability, or you might need to connect your own account for that cloud provider. ")
                                    ])),
                                    _: 2
                                  }, 1032, ["disabled"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.filteredLocationsNotInView.length)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              class: _normalizeClass(["ma-0 token-text-h5 pl-1", { 'mt-4': !!_ctx.filteredLocationsInView?.length }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Icon, {
                                  icon: "eye-off",
                                  class: "ma-0 mr-2"
                                }),
                                _cache[21] || (_cache[21] = _createElementVNode("span", null, " Out of view ", -1)),
                                _createVNode(_component_CustomButton, {
                                  class: "ml-auto my-auto",
                                  level: _ctx.$enums.ButtonLevels.SmallIcon,
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.outOfViewCardsDeployed = !_ctx.outOfViewCardsDeployed))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      icon: "caret-down",
                                      class: _normalizeClass(["caret", { invert: _ctx.outOfViewCardsDeployed }])
                                    }, null, 8, ["class"])
                                  ]),
                                  _: 1
                                }, 8, ["level"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_HeightDeployer, {
                          modelValue: _ctx.outOfViewCardsDeployed,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.outOfViewCardsDeployed) = $event)),
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocationsNotInView, (location, index) => {
                              return (_openBlock(), _createBlock(_component_v_row, {
                                class: "ma-0",
                                key: 'location-card-' + index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Tooltip, {
                                    hoverOnly: true,
                                    forcedPosition: "right",
                                    disabled: 
                    location.attributes.available_server_typologies.length !== 0
                  ,
                                    class: "full-width"
                                  }, {
                                    target: _withCtx(() => [
                                      _createVNode(_component_CardLocation, {
                                        class: "pointer my-1",
                                        dashed: true,
                                        disabled: 
                        location.attributes.available_server_typologies
                          .length === 0
                      ,
                                        location: location,
                                        minPrice: 
                        _ctx.minPricesByLocationId[location.id]
                          ? _ctx.$helpers.prices.format(
                              _ctx.minPricesByLocationId[location.id],
                              _ctx.currency,
                              0,
                            )
                          : ''
                      ,
                                        selected: _ctx.currentLocation?.id === location.id,
                                        onClick: ($event: any) => {
                        if (
                          location.attributes.available_server_typologies
                            .length !== 0
                        )
                          _ctx.selectLocation(location);
                      }
                                      }, null, 8, ["disabled", "location", "minPrice", "selected", "onClick"])
                                    ]),
                                    content: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createTextVNode(" This location is temporarily unavailable."),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" This can be due to a lack of server availability, or you might need to connect your own account for that cloud provider. ")
                                    ])),
                                    _: 2
                                  }, 1032, ["disabled"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.filteredLocations.length === 0)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "ma-0 d-flex full-height align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "pa-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "ma-0 justify-center mb-4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Logo, {
                                          logo: "fransys-sad",
                                          class: "pl-4"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { class: "ma-0 token-text-mediumbold justify-center" }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode(" No result found ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { class: "ma-0 token-text-regular justify-center" }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode(" Please try widening your search criteria. ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0 top-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" From (" + _toDisplayString(_ctx.$enums.CurrencyTrigramToSymbol[_ctx.currency]) + ") - To (" + _toDisplayString(_ctx.$enums.CurrencyTrigramToSymbol[_ctx.currency]) + ") ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 mt-n2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Slider, {
                        values: [0, _ctx.maxOfMinsPrice],
                        step: 1,
                        min: 0,
                        max: _ctx.maxOfMinsPrice,
                        hideThumbLabels: true,
                        hideTicks: true,
                        displayValuesInline: true,
                        valuesInlineAppend: _ctx.$enums.CurrencyTrigramToSymbol[_ctx.currency],
                        range: true,
                        "onUpdateValue:values": _ctx.onSelectPriceFilter
                      }, null, 8, ["values", "max", "valuesInlineAppend", "onUpdateValue:values"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0 ml-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode(" Provider ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomSelect, {
                        items: _ctx.providerListItems,
                        modelValue: _ctx.providerFilterListItem,
                        "onUpdate:modelValue": [
                          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.providerFilterListItem) = $event)),
                          _ctx.onSelectProviderFilter
                        ]
                      }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0 ml-4 fit-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5" }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode(" Require GPU ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0 mt-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Switch, {
                        modelValue: _ctx.requireGPU,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:requireGPU', $event)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0 ml-4 fit-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5 token-text-color-secondary" }, {
                    default: _withCtx(() => [
                      _cache[27] || (_cache[27] = _createTextVNode(" Renewable energy ")),
                      _createVNode(_component_BadgeSoon, { class: "ml-1 mt-1" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomNumberInput, {
                        class: "full-width",
                        placeholder: "No filter",
                        disabled: true,
                        disabledVisible: true,
                        selectedUnit: { label: '%', ratio: 1 },
                        nullable: true,
                        min: 0,
                        max: 100,
                        delay: _ctx.delayOnInput,
                        modelValue: _ctx.minRenewableEnergyFilter,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.minRenewableEnergyFilter) = $event))
                      }, null, 8, ["delay", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pa-0 ml-4 fit-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0 token-text-h5 token-text-color-secondary" }, {
                    default: _withCtx(() => [
                      _cache[28] || (_cache[28] = _createTextVNode(" Certifications ")),
                      _createVNode(_component_BadgeSoon, { class: "ml-1 mt-1" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CustomSelect, {
                        disabled: true,
                        items: _ctx.certicifationsFilterListItems,
                        modelValue: _ctx.certicifationsFilterListItem,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.certicifationsFilterListItem) = $event))
                      }, null, 8, ["items", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "ma-0" }, {
            default: _withCtx(() => [
              (_ctx.showMap)
                ? (_openBlock(), _createBlock(_component_Map, {
                    key: 0,
                    height: "calc(100vh - 196px);",
                    width: "100%",
                    markers: _ctx.markers,
                    markersInView: _ctx.markersInView,
                    "onUpdate:markersInView": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.markersInView) = $event)),
                    ref: "refMap",
                    onClickMapMarker: _ctx.onClickMapMarker
                  }, null, 8, ["markers", "markersInView", "onClickMapMarker"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}